import InputDate from "@/Components/Base/Input/InputDate";
import InputPreco from "@/Components/Base/Input/InputPreco";
import Titulo from "@/Models/Financeiro/Titulo/Titulo";
import { TituloDuplicarPropsType, useListar, useTituloDuplicar } from "@/Services/Financeiro/Titulo/TituloService";
import { Form, FormProps, Col, InputNumber, Card, Flex, Row, Result, notification } from "antd";
import { useMemo, useEffect } from "react";
import dayjs from 'dayjs';
import TelaCarregamento from "@/Components/Base/Carregamento/TelaCarregamento";
import { EnumTituloSituacao } from "@/Models/Financeiro/Titulo/TituloSituacao";
import { PropriedadesDeNotificacao } from "@/Utils/Notificacoes";

export type FaturaDublicarFormType = {
    quantidade:number;
    parcelas:number[];
    titulos:Titulo[];
}

export interface IFaturaDublicarFormBasicProps extends FormProps<FaturaDublicarFormType> {
    codFatura : number;
    onSuccess?: () => void;
    onFinish?:TituloDuplicarPropsType["onSettled"];
}

export default function FaturaDuplicarFormBasic({
    codFatura,
    layout,
    autoComplete,
    component,
    initialValues,
    form : formParam,
    onFinish,
    onSuccess,
    ...props
}:IFaturaDublicarFormBasicProps) {    
    const [newForm] = Form.useForm<FaturaDublicarFormType>();
    const form = formParam ?? newForm;

    const {
        data,
        isLoading
    } = useListar({
        titulo : {
            codFatura : codFatura
        },
        ativo : true,
        enabled : codFatura > 0
    });

    const {
        mutate,
        isPending
    } = useTituloDuplicar({
        onSettled : onFinish,
        onSuccess : () => {
            notification.success({
                ...PropriedadesDeNotificacao["Sucesso"],
                message : "Parcelas duplicadas com sucesso."
            });
            onSuccess?.();
        }
    });

    const quantidadeForm = Form.useWatch("quantidade", form);
    const parcelas = useMemo(() => new Array(quantidadeForm ?? 0).fill(undefined).map((_, i) => i), [quantidadeForm]);
    const parcelasDisponiveis = useMemo(() => data?.filter(f => f.codSituacao !== EnumTituloSituacao.Cancelado), [data]);
    const carregando = isLoading || !(codFatura > 0);

    // useEffect(() => form.resetFields(), [parcelasDisponiveis]);

    if (!isLoading && (parcelasDisponiveis?.length ?? 0) > 1) return <Result
        status="info"
        title="Não permitido"
        subTitle="Desculpe, não é permitido duplicar Título com mais de 1 parcela."
    />;

    if (!isLoading && (parcelasDisponiveis?.length ?? 0) === 0) return <Result
        status="info"
        title="Não encontrado"
        subTitle={`Desculpe, não foi encontrado nenhuma parcela para a fatura ${codFatura}.`}
    />;

    return <TelaCarregamento ativo={isLoading}>
        {/* {isLoading && <></> || (<> */}
            <Form<FaturaDublicarFormType>
                {...props}
                form={form}
                layout={layout ?? "vertical"}
                autoComplete={autoComplete ?? "off"}
                initialValues={{
                    quantidade : 1,
                    ...(initialValues ?? {})
                }}
                onFinish={(dados) => {
                    mutate({
                        codTituloBase : codFatura,
                        titulos : dados.titulos
                    })
                }}
            >
                <Col xs={24} sm={12} md={8} lg={5} xl={4} xxl={3}>
                    <Form.Item<FaturaDublicarFormType> label="Quantidade"
                        /**@ts-ignore */
                        name={["quantidade"]} rules={[{ required : true }]}>
                        <InputNumber addonBefore={<>Nº</>} placeholder="Quantidade" min={0} max={32} />
                    </Form.Item>
                </Col>

                {!carregando && <Form.List name={"titulos"}>
                    {(fields) => (
                        <Flex vertical={true} gap={8}>
                            {
                                parcelas.map(index => (
                                    <Card
                                        size="small"
                                        title={`Parcela ${index + 1}`}
                                        key={index}
                                    >
                                        <Row gutter={8} wrap>
                                            <Col xs={24} sm={12} md={8} lg={6} xl={4} xxl={3}>
                                                <Form.Item<FaturaDublicarFormType> label={"Vencimento"} name={[index, "dataVencimento"]} initialValue={dayjs(form.getFieldValue(["titulos", index - 1, "dataVencimento"]) ?? parcelasDisponiveis?.[0].dataVencimento).add(1, "month")} rules={[{ required: true }]}>
                                                    <InputDate />
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} sm={12} md={8} lg={6} xl={5} xxl={4}>
                                                <Form.Item<FaturaDublicarFormType> label={"Valor base (R$)"} name={[index, "valorBase"]} initialValue={parcelasDisponiveis?.[0].valorBase} rules={[{ required: true }]}>
                                                    <InputPreco
                                                        placeholder="Valor base (R$)"
                                                        addonBefore={<>R$</>}
                                                    />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    </Card>
                                ))
                            }
                        </Flex>
                    )}
                </Form.List>}
            </Form>
        {/* </>)}  */}
    </TelaCarregamento>;
}